import { AxiosInstance } from "../../../axios/axiosInstance";
import { apiRoutes } from "../../../utils/ApiRoutes";
import {
  IAddonPurchaseAiCredits,
  IBillingCheckoutData,
  IPurchaseCredits,
} from "../IApisInterface";

export const purchaseCreditApi = async (payload: IPurchaseCredits) => {
  const response = await AxiosInstance.post(
    apiRoutes?.creditBillCheckout,
    payload,
  );
  return response;
};

export const confirmCreditPurchaseApi = async (id: string) => {
  const response = await AxiosInstance.post(apiRoutes?.creditBillGetSession, {
    id,
  });
  return response;
};

export const getBillingPlanApi = async () => {
  const response = await AxiosInstance.get(apiRoutes?.getPlans);
  return response;
};

export const billingCheckoutApi = async (payload: IBillingCheckoutData) => {
  const response = await AxiosInstance.post(apiRoutes?.billCheckout, payload);
  return response;
};

export const getBillingSessionApi = async (id: string) => {
  const response = await AxiosInstance.post(apiRoutes?.billGetSession, { id });
  return response;
};

export const purchaseAiCreditApi = async (payload: IAddonPurchaseAiCredits) => {
  const response = await AxiosInstance.post(
    apiRoutes?.addonPurchaseAiCredit,
    payload,
  );
  return response;
};

export const confirmPurchaseAiCreditApi = async (id: string) => {
  const response = await AxiosInstance.post(
    apiRoutes?.addonConfirmPurchaseAiCredit,
    { id },
  );
  return response;
};

export const billingCustomerPortalApi = async () => {
  const response = await AxiosInstance.post(apiRoutes?.billingCustomPortal);
  return response;
};

export const billingUpgradePreviewApi = async (
  planId: string,
  type: string,
) => {
  const response = await AxiosInstance.post(apiRoutes?.billingUpgradePreview, {
    planId,
    type,
  });
  return response;
};

export const getCheckinBusinessBillingSummaryApi = async () => {
  const response = await AxiosInstance.post(
    apiRoutes?.checkinBusinessBillingSummary,
  );
  return response;
};

export const getCheckinBusinessBillingTableApi = async (payload: {
  page?: number;
  limit?: number;
  keyword?: string;
  status?: string;
  sort_by?: string;
  sort_order?: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.checkinBusinessBillingTable,
    payload,
  );
  return response;
};

export const getSubscriptionDetailsApi = async () => {
  const response = await AxiosInstance.get(apiRoutes?.getSubscriptionDetails);
  return response;
};

export const restoreSubscriptionApi = async () => {
  const response = await AxiosInstance.post(apiRoutes?.restoreSubscription);
  return response;
};

export const getBillingInvoicesApi = async (payload: {
  page?: number;
  limit?: number;
  sort_by?: string;
  sort_order?: string;
  category_filter?: string;
  date_from?: string;
  date_to?: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.getBillingInvoices,
    payload,
  );
  return response;
};
